var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.otherCategoryProducts.length)?_c('product-carousel',{attrs:{"products":_vm.otherCategoryProducts}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }